import img from "./dz_placeholder_1.jpg";
import img1 from "./dz_placeholder_2.jpg";
import img10 from "./placeholder_11.jpg";
import img11 from "./placeholder_12.jpg";
import img12 from "./placeholder_13.jpg";
import img13 from "./placeholder_14.jpg";
import img14 from "./placeholder_15.jpg";
import img15 from "./placeholder_16.jpg";
import img16 from "./placeholder_17.jpg";
import img17 from "./placeholder_18.jpg";
import img2 from "./dz_placeholder_3.jpg";
import img3 from "./dz_placeholder_4.jpg";
import img4 from "./dz_placeholder_5.jpg";
import img5 from "./dz_placeholder_6.jpg";
import img6 from "./placeholder_7.jpg";
import img7 from "./placeholder_8.jpg";
import img8 from "./placeholder_9.jpg";
import img9 from "./placeholder_10.jpg";

const placeholderImages = [
    img,
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
]

export default placeholderImages